// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// AccountType — source: shared/config/account_types.config.json

export const ACCOUNT_TYPE_VALUES = ["asset", "liability", "equity", "revenue", "direct_cost", "expense"] as const;
export type AccountType = (typeof ACCOUNT_TYPE_VALUES)[number];

export const accountTypeColor: Record<AccountType, string> = {
  "asset": "#4CAF50",
  "liability": "#F44336",
  "equity": "#2196F3",
  "revenue": "#8BC34A",
  "direct_cost": "#FF7043",
  "expense": "#FF9800",
};

